import React from 'react';
import PropTypes from 'prop-types';

import Isvg from 'react-inlinesvg';

class NoticePopup extends React.Component {
    render() {
        const classes = ['popup', 'popup--centered', 'notice-popup'];
        const { onConfirm, onClose, isVisible, title, text, buttonLabel } = this.props;

        if (!isVisible) {
            return null;
        }

        if (/iPhone/.test(navigator.userAgent) && !window.MSStream) {
            classes.push('is-iphone');
        }

        return (
            <div className={classes.join(' ')}>
                <div className="popup__box">
                    <header className="popup__header">
                        <h3 className="popup__title">{title}</h3>

                        {typeof onClose === 'function' ? (
                            <button type="button" className="popup__close" onClick={onClose}>
                                <Isvg src="../../svg/cancel.svg" />
                            </button>
                        ) : null}
                    </header>
                    <div className="popup__body">
                        {Array.isArray(text) ? (
                            text.map((item, i) => {
                                switch (item.type) {
                                    case 'p':
                                        return (
                                            <p key={`p-${i}`} className="popup__text">
                                                {item.props.children}
                                            </p>
                                        );
                                    case 'img':
                                        return {
                                            ...item,
                                            props: { ...item.props, className: 'popup__img' },
                                        };
                                    default:
                                        return item;
                                }
                            })
                        ) : typeof text === 'string' ? (
                            <p className="popup__text">{text}</p>
                        ) : null}
                    </div>
                    <div className="popup__buttons">
                        <button className="is-primary" onClick={onConfirm}>
                            {buttonLabel}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

NoticePopup.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    isVisible: PropTypes.bool.isRequired,
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
    text: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
    buttonLabel: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
};

NoticePopup.defaultProps = {};

export default NoticePopup;
